import styled from 'styled-components';

export const AlertContainer = styled.div<{ $isOpen: boolean }>`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme: { token } }) => token.marginXS}px;
  width: 100%;

  .alert {
    display: flex;
    flex-direction: column;
    gap: ${({ theme: { token } }) => token.marginXS}px;
    width: 100%;
  }

  .alert-header {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
  }

  .alert-footer {
    display: flex;
    justify-content: flex-end;
  }

  .alert-icon-severity-container {
    display: flex;
    align-items: flex-end;
    gap: ${({ theme: { token } }) => token.marginMD}px;

    .alert-icon-severity-label {
      display: flex;
      align-items: flex-end;
      gap: ${({ theme: { token } }) => token.marginXS}px;
    }

    .alert-severity {
      color: ${({ theme: { token } }) => token.colorTextSecondary};
      text-transform: capitalize;
      ${({ $isOpen }) => !$isOpen && `opacity: 0.5;`}
    }
  }

  .alert-date {
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    margin-right: ${({ theme: { token } }) => token.marginXS}px;
    ${({ $isOpen }) => !$isOpen && `opacity: 0.5;`}
  }

  .alert-title {
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    ${({ $isOpen }) => !$isOpen && `opacity: 0.5;`}
  }

  .alert-description {
    color: ${({ theme: { token } }) => token.colorTextSecondary};
    ${({ $isOpen }) => !$isOpen && `opacity: 0.5;`}
  }
`;
